import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useMultipleEntity } from '../../../hooks/useMultipleEntity';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useMultipleEntityWidget = (props) => {
    'use no memo';
    // Could not preserve existing manual memoization
    // Inferred different dependency than source.
    const [validTypeIds] = useState(Object.keys(deviceEnabledTypes));
    const { components, state } = useMultipleEntity({
        contextObject: props.contextCustomer ?? {},
        validTypes: validTypeIds,
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "entityTypeSelector" }), _jsx(Stack, { direction: "row", children: components.entityTypeSelector }), _jsx(Typography, { variant: "h5", children: "entitySelector" }), _jsx(Stack, { direction: "row", children: components.entitySelector })] })), [props.contextCustomer?.sk, state]);
    return {
        name: 'useMultipleEntity',
        category: 'hooks',
        component,
    };
};
